import styled from 'styled-components';

export const SubmitTasksDiv = styled.div`
  display: inline-flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 10px;
`;
